<template>
  <header class="legacy-shell-placeholder"></header>
</template>

<style scoped>
.legacy-shell-placeholder {
  display: none;
}
</style>
